import { font } from 'modules/styles';
import styled from 'styled-components';

const RequestFormHeader = styled.header`
    ${font(16, '#333')}
    text-transform: uppercase;
    margin-bottom: 18px;
    flex: none;
`;

export default RequestFormHeader;
